import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';

const getPathColors = dotColor => {
  return {
    color: colorsPalette.white,
    '.path1:before': {
      color: 'inherit',
    },
    '.path2:before': {
      color: dotColor || 'inherit',
    },
    '.path3:before': {
      color: 'inherit',
    },
    '.path4:before': {
      color: 'inherit',
    },
  };
};

const regusLogoTypes = {
  black: getPathColors(),
  white: getPathColors(colorsPalette.red),
};

export const regusLogoCss = type =>
  css({
    ...regusLogoTypes[type],
  });
